import React from 'react';
import s from './BaseComp.scss';

export const TitleLoading = () => {
    return (
        <div className={s.titleLoadingBox}>
            <div className={s.titleLoading} />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/BaseComp/Title.loading.tsx